<template>
  <j-select-biz-component @input="handleOk" :width="1000" v-bind="configs" v-on="$listeners" :paginationFlag="paginationFlag" :selectButtonText="selectButtonText"/>
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'


  export default {
    name: 'JSelectCstSign',
    components: { JSelectBizComponent },
    props: ['value'],
    props:{
      applicationCode: {
        type: String,
        default: 'cst'
      },
      title:{
        type: String,
        //this.$store.getters.language['system.departSigne.signeNodePerson']
        default: '签核人' //签核人
      }
    },
    data() {
      const { language } = this.$store.getters;
      return {
        selectButtonText:"",
        paginationFlag:false,
        settings: {
          name: this.title,
          displayKey: 'realname',
          returnKeys: ['realname','id'],
          listUrl: '/sys/user/modal_list'+"/"+this.applicationCode,
          queryParamCode: 'usernameAndWorkNo',
          queryParamText: language['esg.userNameOrWorkNo'],//用户名或工号或姓名
          columns: [
            { title: language['construct.name'], dataIndex: 'realname', align: 'center', width: '30%', widthRight: '70%' }, //姓名
            { title: language['system.user.name'], dataIndex: 'username', align: 'center', width: '30%', widthRight: '70%' }, //用户名
            { title: language['column.jobNumber'], dataIndex: 'workNo', align: 'center', width: '30%', widthRight: '70%' }, //工号
            { title: language['column.cellphoneNumber'], dataIndex: 'phone', align: 'center', width: '35%' }, //手机号
            { title: language['column.mailbox'], dataIndex: 'email', align: 'center', width: '25%' } //邮箱
          ]
        }
      }
    },
    computed: {
      configs() {
        return Object.assign({ value: this.value }, this.settings, this.$attrs)
      },
      language() {
            return this.$store.getters.language
      }
    },
    methods:{
      handleOk(val){

        // console.log('JSelectCstSign11111111111',val);
      }
    }
  }
</script>

<style lang="less" scoped></style>